import { CKButton } from '@clearkit/react';
import startCase from 'lodash/startCase';
import { Subscribe } from 'unstated';

import ConnectorsContainer from '~/containers/Connectors';
import { authConnector } from '~/lib/client';
import {
  connectorLocations,
  trackAuthStartedAccountConnector,
  trackConnectedAccountConnector,
} from '~/lib/segmentAnalytics';

import styles from './styles';

class Disconnected extends React.Component {
  authSuccess = () => {
    const {
      connectorsContainer,
      onSuccess,
      service: connectorType,
    } = this.props;

    trackConnectedAccountConnector(
      connectorType,
      connectorLocations.destination,
    );

    connectorsContainer.fetchConnectors();
    onSuccess();
  };

  auth = () => {
    const { service: connectorType } = this.props;

    trackAuthStartedAccountConnector(
      connectorType,
      connectorLocations.destination,
    );

    authConnector(this.getService(), () => this.authSuccess(connectorType));
  };

  getService() {
    const { service } = this.props;
    if (service === 'google') return 'google_oauth2';

    return service;
  }

  render() {
    const {
      connectorsContainer: {
        state: { loading },
      },
      service,
      Logo,
      classes,
    } = this.props;

    const name = startCase(service);

    return (
      <div className={classes.disconnectedContainer}>
        {Logo && <Logo width="60" height="60" />}
        <span className={classes.heading}>
          You have not set up a {name} account yet.
        </span>
        <span className={classes.subheading}>
          Connect to {name} to continue setting up this Destination
        </span>
        <CKButton disabled={loading} variant="secondary" onClick={this.auth}>
          <span>Connect {name}</span>
        </CKButton>
      </div>
    );
  }
}

Disconnected.propTypes = {
  connectorsContainer: PropTypes.object.isRequired,
  service: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  Logo: PropTypes.node,
  classes: PropTypes.object,
};

const WrappedDisconnected = (props) => (
  <Subscribe to={[ConnectorsContainer]}>
    {(connectorsContainer) => (
      <Disconnected connectorsContainer={connectorsContainer} {...props} />
    )}
  </Subscribe>
);

export default withStyles(styles)(WrappedDisconnected);
